import RechargeCreditCardView from "./view";
import { useNavigate } from "react-router-dom";
import { ReducersTypes } from "@/redux/reducers/Models";
import { useSelector } from "react-redux";

import useCreditCardForm from "../hooks/useCreditCardForm";
import { useSingleFlag } from "@/hooks/useFlags";
import Loading from "@/atomic/atoms/Loading";
import useCaptcha from "@/hooks/useCaptcha";
import { useCallback, useMemo, useState } from "react";

export default function RechargeCreditCard() {

  const navigate = useNavigate();
  const customer = useSelector((state: ReducersTypes) => state.customerReducer);
  const { isEnabled: isAutoPaymentEnabled, isLoading: isLoadingAutoPaymentFlag } = useSingleFlag('PD_COBRANCA_DIRETA');
  const { isLoading: isLoadingCaptchaFlag } = useSingleFlag("PD_CAPTCHA_MTCAPTCHA");

  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);
  const [captchaKey, setCaptchaKey] = useState(0);

  const captchaName = useMemo(
    () => `mtcaptcha-recharge-credit-card-${captchaKey}`,
    [captchaKey]
  );

  const setIsCaptchaVerifiedCallback = useCallback((value: boolean) => {
    setIsCaptchaVerified(value);
  }, []);

  useCaptcha({
    setIsVerified: setIsCaptchaVerifiedCallback,
    captchaName,
  });

  const incrementCaptchaKey = useCallback(() => {
    setCaptchaKey((prev) => prev + 1);
  }, []);

  const resetCaptcha = useCallback(() => {
    setIsCaptchaVerified(false);
    if ((window as any)?.mtcaptcha?.resetUI) {
      (window as any).mtcaptcha.resetUI(captchaName);
    }
    incrementCaptchaKey();
  }, [captchaName, incrementCaptchaKey]);

  const {
    toggleModal,
    isVisibleModal,
    isLoading,
    isDisabled,
    register,
    handleSubmit,
    error,
    errorChangeMethod,
    errors,
    isVisibleConfirmationModal,
    handleConfirmAutoPayment,
    handleCancelAutoPayment,
    handleAutoPaymentChange,
    watch,
    attemptCount,
    resetAttemptCount,
  } = useCreditCardForm({
    navigate,
    isAutoPaymentEnabled,
    captchaName,
    isCaptchaVerified,
    resetCaptcha,
  });

  const goBack = () => navigate('/payment');

  const goPaymentOptions = () => navigate('/payment');

  const goToFinished = () => navigate("/payment/finished");

  return (
    <>
      {isLoadingAutoPaymentFlag && <Loading />}
      <RechargeCreditCardView
        isLoading={isLoading}
        goBack={goBack}
        isDisabled={isDisabled}
        error={error}
        errorChangePaymentMethod={errorChangeMethod}
        goToFinished={goToFinished}
        register={register}
        handleSubmit={handleSubmit}
        errors={errors}
        isVisibleModal={isVisibleModal}
        toggleModal={toggleModal}
        isVisibleConfirmationModal={isVisibleConfirmationModal}
        handleConfirmAutoPayment={handleConfirmAutoPayment}
        handleCancelAutoPayment={handleCancelAutoPayment}
        handleAutoPaymentChange={handleAutoPaymentChange}
        customer={customer}
        watch={watch}
        isAutoPaymentEnabled={isAutoPaymentEnabled}
        attemptCount={attemptCount}
        resetAttemptCount={resetAttemptCount}
        goPaymentOptions={goPaymentOptions}
        captchaName={captchaName}
        isCaptchaVerified={isCaptchaVerified}
        isLoadingCaptchaFlag={isLoadingCaptchaFlag}
      />
    </>
  );
}
